import React, { useEffect, useRef, useState } from "react";

//Hooks
import { useHistory } from "react-router-dom";

// Styles
import defaultClasses from "./contentTitle.module.scss";
import { mergeClasses } from "@magento/venia-ui/lib/classify";

//Components
import Button from "../../overrides/venia-ui/components/Button";
var ContentTitle = props => {
  var history = useHistory();
  var {
    title,
    subtitle,
    pre_subtitle,
    button_label,
    button_link
  } = props;
  var classes = mergeClasses(defaultClasses);
  return /*#__PURE__*/React.createElement("div", {
    className: "content-title uk-text-center ".concat(classes.contentTitle)
  }, title ? /*#__PURE__*/React.createElement("h2", {
    className: "uk-text-uppercase title ".concat(classes.title)
  }, title) : null, pre_subtitle ? /*#__PURE__*/React.createElement("div", {
    className: "clear-html pre_description ".concat(classes.pre_description)
  }, /*#__PURE__*/React.createElement("p", null, pre_subtitle)) : null, subtitle ? /*#__PURE__*/React.createElement("div", {
    className: "clear-html description ".concat(classes.description)
  }, /*#__PURE__*/React.createElement("p", null, subtitle)) : null, button_label ? /*#__PURE__*/React.createElement(Button, {
    color: "outline",
    fullScreen: true,
    onClick: () => history.push(button_link)
  }, button_label) : null);
};
export default ContentTitle;